/* eslint-disable max-len */

// Date Presets
export const TODAY = 'today';
export const YESTERDAY = 'yesterday';
export const THIS_MONTH = 'this_month';
export const LAST_MONTH = 'last_month';
export const THIS_QUARTER = 'this_quarter';
export const LAST_QUARTER = 'last_quarter';
export const THIS_YEAR = 'this_year';
export const LAST_YEAR = 'last_year';
export const MAXIMUM = 'maximum';
export const LAST_3D = 'last_3d';
export const LAST_7D = 'last_7d';
export const LAST_14D = 'last_14d';
export const LAST_28D = 'last_28d';
export const LAST_30D = 'last_30d';
export const LAST_90D = 'last_90d';
export const LAST_WEEK_MON_SUN = 'last_week_mon_sun';
export const LAST_WEEK_SUN_SAT = 'last_week_sun_sat';
export const THIS_WEEK_MON_TODAY = 'this_week_mon_today';
export const THIS_WEEK_SUN_TODAY = 'this_week_sun_today';

// Aggregate Periods
export const DAY = 'day';
export const WEEK = 'week';
export const DAYS_28 = 'days_28';
export const LIFETIME = 'lifetime';

// Metrics
export const PAGE_TAB_VIEWS_LOGIN_TOP_UNIQUE = 'page_tab_views_login_top_unique';
export const PAGE_TAB_VIEWS_LOGIN_TOP = 'page_tab_views_login_top';
export const PAGE_TAB_VIEWS_LOGOUT_TOP = 'page_tab_views_logout_top';
export const PAGE_TOTAL_ACTIONS = 'page_total_actions';
export const PAGE_CTA_CLICKS_LOGGED_IN_TOTAL = 'page_cta_clicks_logged_in_total';
export const PAGE_CTA_CLICKS_LOGGED_IN_UNIQUE = 'page_cta_clicks_logged_in_unique';
export const PAGE_CTA_CLICKS_BY_SITE_LOGGED_IN_UNIQUE = 'page_cta_clicks_by_site_logged_in_unique';
export const PAGE_CTA_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE =
  'page_cta_clicks_by_age_gender_logged_in_unique';
export const PAGE_CTA_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE =
  'page_cta_clicks_logged_in_by_country_unique';
export const PAGE_CTA_CLICKS_LOGGED_IN_BY_CITY_UNIQUE = 'page_cta_clicks_logged_in_by_city_unique';
export const PAGE_CALL_PHONE_CLICKS_LOGGED_IN_UNIQUE = 'page_call_phone_clicks_logged_in_unique';
export const PAGE_CALL_PHONE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE =
  'page_call_phone_clicks_by_age_gender_logged_in_unique';
export const PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE =
  'page_call_phone_clicks_logged_in_by_country_unique';
export const PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE =
  'page_call_phone_clicks_logged_in_by_city_unique';
export const PAGE_CALL_PHONE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE =
  'page_call_phone_clicks_by_site_logged_in_unique';
export const PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_UNIQUE =
  'page_get_directions_clicks_logged_in_unique';
export const PAGE_GET_DIRECTIONS_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE =
  'page_get_directions_clicks_by_age_gender_logged_in_unique';
export const PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE =
  'page_get_directions_clicks_logged_in_by_country_unique';
export const PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_CITY_UNIQUE =
  'page_get_directions_clicks_logged_in_by_city_unique';
export const PAGE_GET_DIRECTIONS_CLICKS_BY_SITE_LOGGED_IN_UNIQUE =
  'page_get_directions_clicks_by_site_logged_in_unique';
export const PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE = 'page_website_clicks_logged_in_unique';
export const PAGE_WEBSITE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE =
  'page_website_clicks_by_age_gender_logged_in_unique';
export const PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE =
  'page_website_clicks_logged_in_by_country_unique';
export const PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE =
  'page_website_clicks_logged_in_by_city_unique';
export const PAGE_WEBSITE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE =
  'page_website_clicks_by_site_logged_in_unique';
export const PAGE_ENGAGED_USERS = 'page_engaged_users';
export const PAGE_POST_ENGAGEMENTS = 'page_post_engagements';
export const PAGE_CONSUMPTIONS = 'page_consumptions';
export const PAGE_CONSUMPTIONS_UNIQUE = 'page_consumptions_unique';
export const PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE = 'page_consumptions_by_consumption_type';
export const PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE_UNIQUE =
  'page_consumptions_by_consumption_type_unique';
export const PAGE_PLACES_CHECKIN_TOTAL = 'page_places_checkin_total';
export const PAGE_PLACES_CHECKIN_TOTAL_UNIQUE = 'page_places_checkin_total_unique';
export const PAGE_PLACES_CHECKIN_MOBILE = 'page_places_checkin_mobile';
export const PAGE_PLACES_CHECKIN_MOBILE_UNIQUE = 'page_places_checkin_mobile_unique';
export const PAGE_PLACES_CHECKINS_BY_AGE_GENDER = 'page_places_checkins_by_age_gender';
export const PAGE_PLACES_CHECKINS_BY_LOCALE = 'page_places_checkins_by_locale';
export const PAGE_PLACES_CHECKINS_BY_COUNTRY = 'page_places_checkins_by_country';
export const PAGE_NEGATIVE_FEEDBACK = 'page_negative_feedback';
export const PAGE_NEGATIVE_FEEDBACK_UNIQUE = 'page_negative_feedback_unique';
export const PAGE_NEGATIVE_FEEDBACK_BY_TYPE = 'page_negative_feedback_by_type';
export const PAGE_NEGATIVE_FEEDBACK_BY_TYPE_UNIQUE = 'page_negative_feedback_by_type_unique';
export const PAGE_POSITIVE_FEEDBACK_BY_TYPE = 'page_positive_feedback_by_type';
export const PAGE_POSITIVE_FEEDBACK_BY_TYPE_UNIQUE = 'page_positive_feedback_by_type_unique';
export const PAGE_FANS_ONLINE = 'page_fans_online';
export const PAGE_FANS_ONLINE_PER_DAY = 'page_fans_online_per_day';
export const PAGE_FAN_ADDS_BY_PAID_NON_PAID_UNIQUE = 'page_fan_adds_by_paid_non_paid_unique';
export const PAGE_IMPRESSIONS = 'page_impressions';
export const PAGE_IMPRESSIONS_UNIQUE = 'page_impressions_unique';
export const PAGE_IMPRESSIONS_PAID = 'page_impressions_paid';
export const PAGE_IMPRESSIONS_PAID_UNIQUE = 'page_impressions_paid_unique';
export const PAGE_IMPRESSIONS_ORGANIC = 'page_impressions_organic';
export const PAGE_IMPRESSIONS_ORGANIC_UNIQUE = 'page_impressions_organic_unique';
export const PAGE_IMPRESSIONS_VIRAL = 'page_impressions_viral';
export const PAGE_IMPRESSIONS_VIRAL_UNIQUE = 'page_impressions_viral_unique';
export const PAGE_IMPRESSIONS_NONVIRAL = 'page_impressions_nonviral';
export const PAGE_IMPRESSIONS_NONVIRAL_UNIQUE = 'page_impressions_nonviral_unique';
export const PAGE_IMPRESSIONS_BY_STORY_TYPE = 'page_impressions_by_story_type';
export const PAGE_IMPRESSIONS_BY_STORY_TYPE_UNIQUE = 'page_impressions_by_story_type_unique';
export const PAGE_IMPRESSIONS_BY_CITY_UNIQUE = 'page_impressions_by_city_unique';
export const PAGE_IMPRESSIONS_BY_COUNTRY_UNIQUE = 'page_impressions_by_country_unique';
export const PAGE_IMPRESSIONS_BY_LOCALE_UNIQUE = 'page_impressions_by_locale_unique';
export const PAGE_IMPRESSIONS_BY_AGE_GENDER_UNIQUE = 'page_impressions_by_age_gender_unique';
export const PAGE_IMPRESSIONS_FREQUENCY_DISTRIBUTION = 'page_impressions_frequency_distribution';
export const PAGE_IMPRESSIONS_VIRAL_FREQUENCY_DISTRIBUTION =
  'page_impressions_viral_frequency_distribution';
export const PAGE_POSTS_IMPRESSIONS = 'page_posts_impressions';
export const PAGE_POSTS_IMPRESSIONS_UNIQUE = 'page_posts_impressions_unique';
export const PAGE_POSTS_IMPRESSIONS_PAID = 'page_posts_impressions_paid';
export const PAGE_POSTS_IMPRESSIONS_PAID_UNIQUE = 'page_posts_impressions_paid_unique';
export const PAGE_POSTS_IMPRESSIONS_ORGANIC = 'page_posts_impressions_organic';
export const PAGE_POSTS_IMPRESSIONS_ORGANIC_UNIQUE = 'page_posts_impressions_organic_unique';
export const PAGE_POSTS_SERVED_IMPRESSIONS_ORGANIC_UNIQUE =
  'page_posts_served_impressions_organic_unique';
export const PAGE_POSTS_IMPRESSIONS_VIRAL = 'page_posts_impressions_viral';
export const PAGE_POSTS_IMPRESSIONS_VIRAL_UNIQUE = 'page_posts_impressions_viral_unique';
export const PAGE_POSTS_IMPRESSIONS_NONVIRAL = 'page_posts_impressions_nonviral';
export const PAGE_POSTS_IMPRESSIONS_NONVIRAL_UNIQUE = 'page_posts_impressions_nonviral_unique';
export const PAGE_POSTS_IMPRESSIONS_FREQUENCY_DISTRIBUTION =
  'page_posts_impressions_frequency_distribution';
export const POST_ENGAGED_USERS = 'post_engaged_users';
export const POST_NEGATIVE_FEEDBACK = 'post_negative_feedback';
export const POST_NEGATIVE_FEEDBACK_UNIQUE = 'post_negative_feedback_unique';
export const POST_NEGATIVE_FEEDBACK_BY_TYPE = 'post_negative_feedback_by_type';
export const POST_NEGATIVE_FEEDBACK_BY_TYPE_UNIQUE = 'post_negative_feedback_by_type_unique';
export const POST_ENGAGED_FAN = 'post_engaged_fan';
export const POST_CLICKS = 'post_clicks';
export const POST_CLICKS_UNIQUE = 'post_clicks_unique';
export const POST_CLICKS_BY_TYPE = 'post_clicks_by_type';
export const POST_CLICKS_BY_TYPE_UNIQUE = 'post_clicks_by_type_unique';
export const POST_IMPRESSIONS = 'post_impressions';
export const POST_IMPRESSIONS_UNIQUE = 'post_impressions_unique';
export const POST_IMPRESSIONS_PAID = 'post_impressions_paid';
export const POST_IMPRESSIONS_PAID_UNIQUE = 'post_impressions_paid_unique';
export const POST_IMPRESSIONS_FAN = 'post_impressions_fan';
export const POST_IMPRESSIONS_FAN_UNIQUE = 'post_impressions_fan_unique';
export const POST_IMPRESSIONS_FAN_PAID = 'post_impressions_fan_paid';
export const POST_IMPRESSIONS_FAN_PAID_UNIQUE = 'post_impressions_fan_paid_unique';
export const POST_IMPRESSIONS_ORGANIC = 'post_impressions_organic';
export const POST_IMPRESSIONS_ORGANIC_UNIQUE = 'post_impressions_organic_unique';
export const POST_IMPRESSIONS_VIRAL = 'post_impressions_viral';
export const POST_IMPRESSIONS_VIRAL_UNIQUE = 'post_impressions_viral_unique';
export const POST_IMPRESSIONS_NONVIRAL = 'post_impressions_nonviral';
export const POST_IMPRESSIONS_NONVIRAL_UNIQUE = 'post_impressions_nonviral_unique';
export const POST_IMPRESSIONS_BY_STORY_TYPE = 'post_impressions_by_story_type';
export const POST_IMPRESSIONS_BY_STORY_TYPE_UNIQUE = 'post_impressions_by_story_type_unique';
export const POST_REACTIONS_LIKE_TOTAL = 'post_reactions_like_total';
export const POST_REACTIONS_LOVE_TOTAL = 'post_reactions_love_total';
export const POST_REACTIONS_WOW_TOTAL = 'post_reactions_wow_total';
export const POST_REACTIONS_HAHA_TOTAL = 'post_reactions_haha_total';
export const POST_REACTIONS_SORRY_TOTAL = 'post_reactions_sorry_total';
export const POST_REACTIONS_ANGER_TOTAL = 'post_reactions_anger_total';
export const POST_REACTIONS_BY_TYPE_TOTAL = 'post_reactions_by_type_total';
export const PAGE_ACTIONS_POST_REACTIONS_LIKE_TOTAL = 'page_actions_post_reactions_like_total';
export const PAGE_ACTIONS_POST_REACTIONS_LOVE_TOTAL = 'page_actions_post_reactions_love_total';
export const PAGE_ACTIONS_POST_REACTIONS_WOW_TOTAL = 'page_actions_post_reactions_wow_total';
export const PAGE_ACTIONS_POST_REACTIONS_HAHA_TOTAL = 'page_actions_post_reactions_haha_total';
export const PAGE_ACTIONS_POST_REACTIONS_SORRY_TOTAL = 'page_actions_post_reactions_sorry_total';
export const PAGE_ACTIONS_POST_REACTIONS_ANGER_TOTAL = 'page_actions_post_reactions_anger_total';
export const PAGE_ACTIONS_POST_REACTIONS_TOTAL = 'page_actions_post_reactions_total';
export const PAGE_FANS = 'page_fans';
export const PAGE_FANS_LOCALE = 'page_fans_locale';
export const PAGE_FANS_CITY = 'page_fans_city';
export const PAGE_FANS_COUNTRY = 'page_fans_country';
export const PAGE_FANS_GENDER_AGE = 'page_fans_gender_age';
export const PAGE_FAN_ADDS = 'page_fan_adds';
export const PAGE_FAN_ADDS_UNIQUE = 'page_fan_adds_unique';
export const PAGE_FANS_BY_LIKE_SOURCE = 'page_fans_by_like_source';
export const PAGE_FANS_BY_LIKE_SOURCE_UNIQUE = 'page_fans_by_like_source_unique';
export const PAGE_FAN_REMOVES = 'page_fan_removes';
export const PAGE_FAN_REMOVES_UNIQUE = 'page_fan_removes_unique';
export const PAGE_FANS_BY_UNLIKE_SOURCE_UNIQUE = 'page_fans_by_unlike_source_unique';
export const PAGE_VIDEO_VIEWS = 'page_video_views';
export const PAGE_VIDEO_VIEWS_PAID = 'page_video_views_paid';
export const PAGE_VIDEO_VIEWS_ORGANIC = 'page_video_views_organic';
export const PAGE_VIDEO_VIEWS_BY_PAID_NON_PAID = 'page_video_views_by_paid_non_paid';
export const PAGE_VIDEO_VIEWS_AUTOPLAYED = 'page_video_views_autoplayed';
export const PAGE_VIDEO_VIEWS_CLICK_TO_PLAY = 'page_video_views_click_to_play';
export const PAGE_VIDEO_VIEWS_UNIQUE = 'page_video_views_unique';
export const PAGE_VIDEO_REPEAT_VIEWS = 'page_video_repeat_views';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S = 'page_video_complete_views_30s';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S_PAID = 'page_video_complete_views_30s_paid';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S_ORGANIC = 'page_video_complete_views_30s_organic';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED = 'page_video_complete_views_30s_autoplayed';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S_CLICK_TO_PLAY =
  'page_video_complete_views_30s_click_to_play';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S_UNIQUE = 'page_video_complete_views_30s_unique';
export const PAGE_VIDEO_COMPLETE_VIEWS_30S_REPEAT_VIEWS =
  'page_video_complete_views_30s_repeat_views';
export const POST_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED = 'post_video_complete_views_30s_autoplayed';
export const POST_VIDEO_COMPLETE_VIEWS_30S_CLICKED_TO_PLAY =
  'post_video_complete_views_30s_clicked_to_play';
export const POST_VIDEO_COMPLETE_VIEWS_30S_ORGANIC = 'post_video_complete_views_30s_organic';
export const POST_VIDEO_COMPLETE_VIEWS_30S_PAID = 'post_video_complete_views_30s_paid';
export const POST_VIDEO_COMPLETE_VIEWS_30S_UNIQUE = 'post_video_complete_views_30s_unique';
export const PAGE_VIDEO_VIEWS_10S = 'page_video_views_10s';
export const PAGE_VIDEO_VIEWS_10S_PAID = 'page_video_views_10s_paid';
export const PAGE_VIDEO_VIEWS_10S_ORGANIC = 'page_video_views_10s_organic';
export const PAGE_VIDEO_VIEWS_10S_AUTOPLAYED = 'page_video_views_10s_autoplayed';
export const PAGE_VIDEO_VIEWS_10S_CLICK_TO_PLAY = 'page_video_views_10s_click_to_play';
export const PAGE_VIDEO_VIEWS_10S_UNIQUE = 'page_video_views_10s_unique';
export const PAGE_VIDEO_VIEWS_10S_REPEAT = 'page_video_views_10s_repeat';
export const PAGE_VIDEO_VIEW_TIME = 'page_video_view_time';
export const PAGE_VIEWS_TOTAL = 'page_views_total';
export const PAGE_VIEWS_LOGOUT = 'page_views_logout';
export const PAGE_VIEWS_LOGGED_IN_TOTAL = 'page_views_logged_in_total';
export const PAGE_VIEWS_LOGGED_IN_UNIQUE = 'page_views_logged_in_unique';
export const PAGE_VIEWS_EXTERNAL_REFERRALS = 'page_views_external_referrals';
export const PAGE_VIEWS_BY_PROFILE_TAB_TOTAL = 'page_views_by_profile_tab_total';
export const PAGE_VIEWS_BY_PROFILE_TAB_LOGGED_IN_UNIQUE =
  'page_views_by_profile_tab_logged_in_unique';
export const PAGE_VIEWS_BY_INTERNAL_REFERER_LOGGED_IN_UNIQUE =
  'page_views_by_internal_referer_logged_in_unique';
export const PAGE_VIEWS_BY_SITE_LOGGED_IN_UNIQUE = 'page_views_by_site_logged_in_unique';
export const PAGE_VIEWS_BY_AGE_GENDER_LOGGED_IN_UNIQUE =
  'page_views_by_age_gender_logged_in_unique';
export const PAGE_VIEWS_BY_REFERERS_LOGGED_IN_UNIQUE = 'page_views_by_referers_logged_in_unique';
export const POST_VIDEO_AVG_TIME_WATCHED = 'post_video_avg_time_watched';
export const POST_VIDEO_COMPLETE_VIEWS_ORGANIC = 'post_video_complete_views_organic';
export const POST_VIDEO_COMPLETE_VIEWS_ORGANIC_UNIQUE = 'post_video_complete_views_organic_unique';
export const POST_VIDEO_COMPLETE_VIEWS_PAID = 'post_video_complete_views_paid';
export const POST_VIDEO_COMPLETE_VIEWS_PAID_UNIQUE = 'post_video_complete_views_paid_unique';
export const POST_VIDEO_RETENTION_GRAPH = 'post_video_retention_graph';
export const POST_VIDEO_RETENTION_GRAPH_CLICKED_TO_PLAY =
  'post_video_retention_graph_clicked_to_play';
export const POST_VIDEO_RETENTION_GRAPH_AUTOPLAYED = 'post_video_retention_graph_autoplayed';
export const POST_VIDEO_VIEWS_ORGANIC = 'post_video_views_organic';
export const POST_VIDEO_VIEWS_ORGANIC_UNIQUE = 'post_video_views_organic_unique';
export const POST_VIDEO_VIEWS_PAID = 'post_video_views_paid';
export const POST_VIDEO_VIEWS_PAID_UNIQUE = 'post_video_views_paid_unique';
export const POST_VIDEO_LENGTH = 'post_video_length';
export const POST_VIDEO_VIEWS = 'post_video_views';
export const POST_VIDEO_VIEWS_UNIQUE = 'post_video_views_unique';
export const POST_VIDEO_VIEWS_AUTOPLAYED = 'post_video_views_autoplayed';
export const POST_VIDEO_VIEWS_CLICKED_TO_PLAY = 'post_video_views_clicked_to_play';
export const POST_VIDEO_VIEWS_15S = 'post_video_views_15s';
export const POST_VIDEO_VIEWS_60S_EXCLUDES_SHORTER = 'post_video_views_60s_excludes_shorter';
export const POST_VIDEO_VIEWS_10S = 'post_video_views_10s';
export const POST_VIDEO_VIEWS_10S_UNIQUE = 'post_video_views_10s_unique';
export const POST_VIDEO_VIEWS_10S_AUTOPLAYED = 'post_video_views_10s_autoplayed';
export const POST_VIDEO_VIEWS_10S_CLICKED_TO_PLAY = 'post_video_views_10s_clicked_to_play';
export const POST_VIDEO_VIEWS_10S_ORGANIC = 'post_video_views_10s_organic';
export const POST_VIDEO_VIEWS_10S_PAID = 'post_video_views_10s_paid';
export const POST_VIDEO_VIEWS_10S_SOUND_ON = 'post_video_views_10s_sound_on';
export const POST_VIDEO_VIEWS_SOUND_ON = 'post_video_views_sound_on';
export const POST_VIDEO_VIEW_TIME = 'post_video_view_time';
export const POST_VIDEO_VIEW_TIME_ORGANIC = 'post_video_view_time_organic';
export const POST_VIDEO_VIEW_TIME_BY_AGE_BUCKET_AND_GENDER =
  'post_video_view_time_by_age_bucket_and_gender';
export const POST_VIDEO_VIEW_TIME_BY_REGION_ID = 'post_video_view_time_by_region_id';
export const POST_VIDEO_VIEWS_BY_DISTRIBUTION_TYPE = 'post_video_views_by_distribution_type';
export const POST_VIDEO_VIEW_TIME_BY_DISTRIBUTION_TYPE =
  'post_video_view_time_by_distribution_type';
export const POST_VIDEO_VIEW_TIME_BY_COUNTRY_ID = 'post_video_view_time_by_country_id';
export const PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE_UNIQUE =
  'page_content_activity_by_action_type_unique';
export const PAGE_CONTENT_ACTIVITY_BY_AGE_GENDER_UNIQUE =
  'page_content_activity_by_age_gender_unique';
export const PAGE_CONTENT_ACTIVITY_BY_CITY_UNIQUE = 'page_content_activity_by_city_unique';
export const PAGE_CONTENT_ACTIVITY_BY_COUNTRY_UNIQUE = 'page_content_activity_by_country_unique';
export const PAGE_CONTENT_ACTIVITY_BY_LOCALE_UNIQUE = 'page_content_activity_by_locale_unique';
export const PAGE_CONTENT_ACTIVITY = 'page_content_activity';
export const PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE = 'page_content_activity_by_action_type';
export const POST_ACTIVITY = 'post_activity';
export const POST_ACTIVITY_UNIQUE = 'post_activity_unique';
export const POST_ACTIVITY_BY_ACTION_TYPE = 'post_activity_by_action_type';
export const POST_ACTIVITY_BY_ACTION_TYPE_UNIQUE = 'post_activity_by_action_type_unique';
export const PAGE_DAILY_VIDEO_AD_BREAK_AD_IMPRESSIONS_BY_CROSSPOST_STATUS =
  'page_daily_video_ad_break_ad_impressions_by_crosspost_status';
export const PAGE_DAILY_VIDEO_AD_BREAK_CPM_BY_CROSSPOST_STATUS =
  'page_daily_video_ad_break_cpm_by_crosspost_status';
export const PAGE_DAILY_VIDEO_AD_BREAK_EARNINGS_BY_CROSSPOST_STATUS =
  'page_daily_video_ad_break_earnings_by_crosspost_status';
export const POST_VIDEO_AD_BREAK_AD_IMPRESSIONS = 'post_video_ad_break_ad_impressions';
export const POST_VIDEO_AD_BREAK_EARNINGS = 'post_video_ad_break_earnings';
export const POST_VIDEO_AD_BREAK_AD_CPM = 'post_video_ad_break_ad_cpm';
export const AUDIENCE_CITY = 'audience_city';
export const AUDIENCE_COUNTRY = 'audience_country';
export const AUDIENCE_GENDER_AGE = 'audience_gender_age';
export const AUDIENCE_LOCALE = 'audience_locale';
export const EMAIL_CONTACTS = 'email_contacts';
export const FOLLOWER_COUNT = 'follower_count';
export const GET_DIRECTIONS_CLICKS = 'get_directions_clicks';
export const IMPRESSIONS = 'impressions';
export const ONLINE_FOLLOWERS = 'online_followers';
export const PHONE_CALL_CLICKS = 'phone_call_clicks';
export const PROFILE_VIEWS = 'profile_views';
export const REACH = 'reach';
export const TEXT_MESSAGE_CLICKS = 'text_message_clicks';
export const WEBSITE_CLICKS = 'website_clicks';

export const datePresetOptions = [
  { label: 'Today', value: TODAY },
  { label: 'Yesterday', value: YESTERDAY },
  { label: 'This month', value: THIS_MONTH },
  { label: 'Last month', value: LAST_MONTH },
  { label: 'This quarter', value: THIS_QUARTER },
  { label: 'Last quarter', value: LAST_QUARTER },
  { label: 'This year', value: THIS_YEAR },
  { label: 'Last year', value: LAST_YEAR },
  { label: 'Maximum', value: MAXIMUM },
  { label: 'Last 3 days', value: LAST_3D },
  { label: 'Last 7 days', value: LAST_7D },
  { label: 'Last 14 days', value: LAST_14D },
  { label: 'Last 28 days', value: LAST_28D },
  { label: 'Last 30 days', value: LAST_30D },
  { label: 'Last 90 days', value: LAST_90D },
  { label: 'Last week Mon-Sun', value: LAST_WEEK_MON_SUN },
  { label: 'Last week Sun-Sat', value: LAST_WEEK_SUN_SAT },
  { label: 'This week Mon-Today', value: THIS_WEEK_MON_TODAY },
  { label: 'Last week Sun-Today', value: THIS_WEEK_SUN_TODAY },
];

export const periodOptions = [
  { label: 'Day', value: DAY },
  { label: 'Week', value: WEEK },
  { label: '28 Days', value: DAYS_28 },
  { label: 'Lifetime', value: LIFETIME },
];

export const metrics = {
  [PAGE_TAB_VIEWS_LOGIN_TOP_UNIQUE]: {
    label: 'page_tab_views_login_top_unique',
    value: PAGE_TAB_VIEWS_LOGIN_TOP_UNIQUE,
    description: 'The number of users logged in to Facebook who saw tabs on your Page.',
    periods: [DAY, WEEK],
  },
  [PAGE_TAB_VIEWS_LOGIN_TOP]: {
    label: 'page_tab_views_login_top',
    value: PAGE_TAB_VIEWS_LOGIN_TOP,
    description: 'The number of times users logged in to Facebook saw tabs on your Page.',
    periods: [DAY, WEEK],
  },
  [PAGE_TAB_VIEWS_LOGOUT_TOP]: {
    label: 'page_tab_views_logout_top',
    value: PAGE_TAB_VIEWS_LOGOUT_TOP,
    description: 'The number of times users not logged in to Facebook saw tabs on your Page.',
    periods: [DAY],
  },
  [PAGE_TOTAL_ACTIONS]: {
    label: 'page_total_actions',
    value: PAGE_TOTAL_ACTIONS,
    description: "The number of clicks on your Page's contact info and call-to-action button.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CTA_CLICKS_LOGGED_IN_TOTAL]: {
    label: 'page_cta_clicks_logged_in_total',
    value: PAGE_CTA_CLICKS_LOGGED_IN_TOTAL,
    description:
      'Total number of clicks on the Page CTA button by people who are logged in to Facebook.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CTA_CLICKS_LOGGED_IN_UNIQUE]: {
    label: 'page_cta_clicks_logged_in_unique',
    value: PAGE_CTA_CLICKS_LOGGED_IN_UNIQUE,
    description:
      'Unique number of clicks on the Page CTA button by people who are logged in to Facebook.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CTA_CLICKS_BY_SITE_LOGGED_IN_UNIQUE]: {
    label: 'page_cta_clicks_by_site_logged_in_unique',
    value: PAGE_CTA_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
    description:
      'Number of people who are logged in to Facebook and clicked on the CTA button, broken down by www, mobile, api or other.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CTA_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE]: {
    label: 'page_cta_clicks_by_age_gender_logged_in_unique',
    value: PAGE_CTA_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
    description:
      'Number of people who are logged in to Facebook and clicked the Page CTA button, broken down by age and gender group.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CTA_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE]: {
    label: 'page_cta_clicks_logged_in_by_country_unique',
    value: PAGE_CTA_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
    description:
      'Number of people who are logged in to Facebook and clicked the Page CTA button, broken down by country.',
    periods: [DAY, WEEK],
  },
  [PAGE_CTA_CLICKS_LOGGED_IN_BY_CITY_UNIQUE]: {
    label: 'page_cta_clicks_logged_in_by_city_unique',
    value: PAGE_CTA_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
    description:
      'Number of people who are logged in to Facebook and clicked the Page CTA button, broken down by city.',
    periods: [DAY, WEEK],
  },
  [PAGE_CALL_PHONE_CLICKS_LOGGED_IN_UNIQUE]: {
    label: 'page_call_phone_clicks_logged_in_unique',
    value: PAGE_CALL_PHONE_CLICKS_LOGGED_IN_UNIQUE,
    description: 'Number of people who logged in to Facebook and clicked the Call Now button.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CALL_PHONE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE]: {
    label: 'page_call_phone_clicks_by_age_gender_logged_in_unique',
    value: PAGE_CALL_PHONE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Call Now button, broken down by age and gender group.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE]: {
    label: 'page_call_phone_clicks_logged_in_by_country_unique',
    value: PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Call Now button, broken down by countries.',
    periods: [DAY, WEEK],
  },
  [PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE]: {
    label: 'page_call_phone_clicks_logged_in_by_city_unique',
    value: PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Call Now button, broken down by city.',
    periods: [DAY, WEEK],
  },
  [PAGE_CALL_PHONE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE]: {
    label: 'page_call_phone_clicks_by_site_logged_in_unique',
    value: PAGE_CALL_PHONE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
    description:
      "The number of people who clicked your Page's phone number or Call Now button while they were logged into Facebook, broken down by the type of device they used.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_UNIQUE]: {
    label: 'page_get_directions_clicks_logged_in_unique',
    value: PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Get Directions button.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_GET_DIRECTIONS_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE]: {
    label: 'page_get_directions_clicks_by_age_gender_logged_in_unique',
    value: PAGE_GET_DIRECTIONS_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Get Directions button, broken down by age and gender group.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE]: {
    label: 'page_get_directions_clicks_logged_in_by_country_unique',
    value: PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Get Directions button, broken down by country.',
    periods: [DAY, WEEK],
  },
  [PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_CITY_UNIQUE]: {
    label: 'page_get_directions_clicks_logged_in_by_city_unique',
    value: PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Get Directions button, broken down by city.',
    periods: [DAY, WEEK],
  },
  [PAGE_GET_DIRECTIONS_CLICKS_BY_SITE_LOGGED_IN_UNIQUE]: {
    label: 'page_get_directions_clicks_by_site_logged_in_unique',
    value: PAGE_GET_DIRECTIONS_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Get Directions button, broken down by www, mobile, api or other.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE]: {
    label: 'page_website_clicks_logged_in_unique',
    value: PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the goto website CTA button.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_WEBSITE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE]: {
    label: 'page_website_clicks_by_age_gender_logged_in_unique',
    value: PAGE_WEBSITE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the goto website CTA button, broken down by age and gender group.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE]: {
    label: 'page_website_clicks_logged_in_by_country_unique',
    value: PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the goto website CTA button, broken down by country.',
    periods: [DAY, WEEK],
  },
  [PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE]: {
    label: 'page_website_clicks_logged_in_by_city_unique',
    value: PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the goto website CTA button, broken down by city.',
    periods: [DAY, WEEK],
  },
  [PAGE_WEBSITE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE]: {
    label: 'page_website_clicks_by_site_logged_in_unique',
    value: PAGE_WEBSITE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
    description:
      'Number of people who logged in to Facebook and clicked the Page CTA button, broken down by www, mobile, api and other.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ENGAGED_USERS]: {
    label: 'page_engaged_users',
    value: PAGE_ENGAGED_USERS,
    description: 'The number of people who engaged with your Page. Engagement includes any click.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POST_ENGAGEMENTS]: {
    label: 'page_post_engagements',
    value: PAGE_POST_ENGAGEMENTS,
    description:
      'The number of times people have engaged with your posts through reactions, comments, shares and more.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONSUMPTIONS]: {
    label: 'page_consumptions',
    value: PAGE_CONSUMPTIONS,
    description: 'The number of times people clicked on any of your content.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONSUMPTIONS_UNIQUE]: {
    label: 'page_consumptions_unique',
    value: PAGE_CONSUMPTIONS_UNIQUE,
    description: 'The number of people who clicked on any of your content.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE]: {
    label: 'page_consumptions_by_consumption_type',
    value: PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE,
    description: 'The number of times people clicked on any of your content, by type.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE_UNIQUE]: {
    label: 'page_consumptions_by_consumption_type_unique',
    value: PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE_UNIQUE,
    description: 'The number of people who clicked on any of your content, by type.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_PLACES_CHECKIN_TOTAL]: {
    label: 'page_places_checkin_total',
    value: PAGE_PLACES_CHECKIN_TOTAL,
    description: 'The number of times people checked into a place.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_PLACES_CHECKIN_TOTAL_UNIQUE]: {
    label: 'page_places_checkin_total_unique',
    value: PAGE_PLACES_CHECKIN_TOTAL_UNIQUE,
    description: 'The number of people who checked into a place.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_PLACES_CHECKIN_MOBILE]: {
    label: 'page_places_checkin_mobile',
    value: PAGE_PLACES_CHECKIN_MOBILE,
    description: 'The number of times people checked into a place using mobile phones.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_PLACES_CHECKIN_MOBILE_UNIQUE]: {
    label: 'page_places_checkin_mobile_unique',
    value: PAGE_PLACES_CHECKIN_MOBILE_UNIQUE,
    description: 'The number of people who checked into a place using mobile phones.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_PLACES_CHECKINS_BY_AGE_GENDER]: {
    label: 'page_places_checkins_by_age_gender',
    value: PAGE_PLACES_CHECKINS_BY_AGE_GENDER,
    description: 'Gender and age of people who checked in at your Place.',
    periods: [DAY],
  },
  [PAGE_PLACES_CHECKINS_BY_LOCALE]: {
    label: 'page_places_checkins_by_locale',
    value: PAGE_PLACES_CHECKINS_BY_LOCALE,
    description: 'Top locales of people who checked into your Place.',
    periods: [DAY],
  },
  [PAGE_PLACES_CHECKINS_BY_COUNTRY]: {
    label: 'page_places_checkins_by_country',
    value: PAGE_PLACES_CHECKINS_BY_COUNTRY,
    description: 'Top countries of people who checked into your Place.',
    periods: [DAY],
  },
  [PAGE_NEGATIVE_FEEDBACK]: {
    label: 'page_negative_feedback',
    value: PAGE_NEGATIVE_FEEDBACK,
    description:
      'The number of times people took a negative action (e.g., un-liked or hid a post).',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_NEGATIVE_FEEDBACK_UNIQUE]: {
    label: 'page_negative_feedback_unique',
    value: PAGE_NEGATIVE_FEEDBACK_UNIQUE,
    description: 'The number of people who took a negative action (e.g., un-liked or hid a post).',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_NEGATIVE_FEEDBACK_BY_TYPE]: {
    label: 'page_negative_feedback_by_type',
    value: PAGE_NEGATIVE_FEEDBACK_BY_TYPE,
    description: 'The number of times people took a negative action broken down by type.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_NEGATIVE_FEEDBACK_BY_TYPE_UNIQUE]: {
    label: 'page_negative_feedback_by_type_unique',
    value: PAGE_NEGATIVE_FEEDBACK_BY_TYPE_UNIQUE,
    description: 'The number of people who took a negative action broken down by type.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSITIVE_FEEDBACK_BY_TYPE]: {
    label: 'page_positive_feedback_by_type',
    value: PAGE_POSITIVE_FEEDBACK_BY_TYPE,
    description: 'The number of times people took a positive action broken down by type.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSITIVE_FEEDBACK_BY_TYPE_UNIQUE]: {
    label: 'page_positive_feedback_by_type_unique',
    value: PAGE_POSITIVE_FEEDBACK_BY_TYPE_UNIQUE,
    description: 'The number of people who took a positive action broken down by type.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_FANS_ONLINE]: {
    label: 'page_fans_online',
    value: PAGE_FANS_ONLINE,
    description:
      'The number of your fans who saw any posts on Facebook on a given day, broken down by hour of day in PST/PDT.',
    periods: [DAY],
  },
  [PAGE_FANS_ONLINE_PER_DAY]: {
    label: 'page_fans_online_per_day',
    value: PAGE_FANS_ONLINE_PER_DAY,
    description: 'The number of your fans who saw any posts on Facebook on a given day.',
    periods: [DAY],
  },
  [PAGE_FAN_ADDS_BY_PAID_NON_PAID_UNIQUE]: {
    label: 'page_fan_adds_by_paid_non_paid_unique',
    value: PAGE_FAN_ADDS_BY_PAID_NON_PAID_UNIQUE,
    description:
      'The number of new people who have liked your Page broken down by paid and non-paid.',
    periods: [DAY],
  },
  [PAGE_IMPRESSIONS]: {
    label: 'page_impressions',
    value: PAGE_IMPRESSIONS,
    description:
      "The number of times any content from your Page or about your Page entered a person's screen. This includes posts, stories, ads, as well other content or information on your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_UNIQUE]: {
    label: 'page_impressions_unique',
    value: PAGE_IMPRESSIONS_UNIQUE,
    description:
      'The number of people who had any content from your Page or about your Page enter their screen. This includes posts, stories, check-ins, ads, social information from people who interact with your Page and more.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_PAID]: {
    label: 'page_impressions_paid',
    value: PAGE_IMPRESSIONS_PAID,
    description:
      "The number of times any post or story content from your Page or about your Page entered a person's screen through paid distribution such as an ad.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_PAID_UNIQUE]: {
    label: 'page_impressions_paid_unique',
    value: PAGE_IMPRESSIONS_PAID_UNIQUE,
    description:
      'The number of people who had any content from your Page or about your Page enter their screen through paid distribution such as an ad.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_ORGANIC]: {
    label: 'page_impressions_organic',
    value: PAGE_IMPRESSIONS_ORGANIC,
    description:
      "The number of times any post or story content from your Page or about your Page entered a person's screen through unpaid distribution.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_ORGANIC_UNIQUE]: {
    label: 'page_impressions_organic_unique',
    value: PAGE_IMPRESSIONS_ORGANIC_UNIQUE,
    description:
      'The number of people who had any content from your Page or about your Page enter their screen through unpaid distribution. This includes posts, stories, check-ins, social information from people who interact with your Page and more.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_VIRAL]: {
    label: 'page_impressions_viral',
    value: PAGE_IMPRESSIONS_VIRAL,
    description:
      "The number of times any content from your Page or about your Page entered a person's screen with social information attached. Social information displays when a person's friend interacted with your Page, post or story. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_VIRAL_UNIQUE]: {
    label: 'page_impressions_viral_unique',
    value: PAGE_IMPRESSIONS_VIRAL_UNIQUE,
    description:
      "The number of people who had any content from your Page or about your Page enter their screen through with social information attached. As a form of organic distribution, social information displays when a person's friend interacted with your Page, post or story. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_NONVIRAL]: {
    label: 'page_impressions_nonviral',
    value: PAGE_IMPRESSIONS_NONVIRAL,
    description:
      "The number of times any content from your Page entered a person's screen. This does not include content created about your Page with social information attached. Social information displays when a person's friend interacted with your Page, post or story. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_NONVIRAL_UNIQUE]: {
    label: 'page_impressions_nonviral_unique',
    value: PAGE_IMPRESSIONS_NONVIRAL_UNIQUE,
    description:
      "The number of people who had any content from your Page enter their screen. This does not include content created about your Page with social information attached. As a form of organic distribution, social information displays when a person's friend interacted with your Page, post or story. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_BY_STORY_TYPE]: {
    label: 'page_impressions_by_story_type',
    value: PAGE_IMPRESSIONS_BY_STORY_TYPE,
    description:
      'Total impressions of posts published by a friend about your Page by type. (See possible types)',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_BY_STORY_TYPE_UNIQUE]: {
    label: 'page_impressions_by_story_type_unique',
    value: PAGE_IMPRESSIONS_BY_STORY_TYPE_UNIQUE,
    description:
      'The number of people who saw posts published by a friend about your Page by type. (See possible types)',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_BY_CITY_UNIQUE]: {
    label: 'page_impressions_by_city_unique',
    value: PAGE_IMPRESSIONS_BY_CITY_UNIQUE,
    description:
      'The number of people who have seen any content associated with your Page by city.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_BY_COUNTRY_UNIQUE]: {
    label: 'page_impressions_by_country_unique',
    value: PAGE_IMPRESSIONS_BY_COUNTRY_UNIQUE,
    description:
      'The number of people who have seen any content associated with your Page by country.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_BY_LOCALE_UNIQUE]: {
    label: 'page_impressions_by_locale_unique',
    value: PAGE_IMPRESSIONS_BY_LOCALE_UNIQUE,
    description:
      'The number of people who have seen any content associated with your Page by user selected language.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_BY_AGE_GENDER_UNIQUE]: {
    label: 'page_impressions_by_age_gender_unique',
    value: PAGE_IMPRESSIONS_BY_AGE_GENDER_UNIQUE,
    description:
      'The number of people who saw any content by your Page or about your Page, grouped by age and gender. This number is an estimate.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_FREQUENCY_DISTRIBUTION]: {
    label: 'page_impressions_frequency_distribution',
    value: PAGE_IMPRESSIONS_FREQUENCY_DISTRIBUTION,
    description:
      'The number of people your Page reached broken down by how many times people saw any content about your Page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_IMPRESSIONS_VIRAL_FREQUENCY_DISTRIBUTION]: {
    label: 'page_impressions_viral_frequency_distribution',
    value: PAGE_IMPRESSIONS_VIRAL_FREQUENCY_DISTRIBUTION,
    description:
      'The number of people your Page reached from a story published by a friend, broken down by how many times people saw stories about your Page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS]: {
    label: 'page_posts_impressions',
    value: PAGE_POSTS_IMPRESSIONS,
    description:
      "The number of times your Page's posts entered a person's screen. Posts include statuses, photos, links, videos and more.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_UNIQUE]: {
    label: 'page_posts_impressions_unique',
    value: PAGE_POSTS_IMPRESSIONS_UNIQUE,
    description:
      "The number of people who had any of your Page's posts enter their screen. Posts include statuses, photos, links, videos and more.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_PAID]: {
    label: 'page_posts_impressions_paid',
    value: PAGE_POSTS_IMPRESSIONS_PAID,
    description:
      "The number of times your Page's posts entered a person's screen through paid distribution such as an ad.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_PAID_UNIQUE]: {
    label: 'page_posts_impressions_paid_unique',
    value: PAGE_POSTS_IMPRESSIONS_PAID_UNIQUE,
    description:
      "The number of people who had any of your Page's posts enter their screen through paid distribution such as an ad.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_ORGANIC]: {
    label: 'page_posts_impressions_organic',
    value: PAGE_POSTS_IMPRESSIONS_ORGANIC,
    description:
      "The number of times your Page's posts entered a person's screen through unpaid distribution.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_ORGANIC_UNIQUE]: {
    label: 'page_posts_impressions_organic_unique',
    value: PAGE_POSTS_IMPRESSIONS_ORGANIC_UNIQUE,
    description:
      "The number of people who had any of your Page's posts enter their screen through unpaid distribution.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_SERVED_IMPRESSIONS_ORGANIC_UNIQUE]: {
    label: 'page_posts_served_impressions_organic_unique',
    value: PAGE_POSTS_SERVED_IMPRESSIONS_ORGANIC_UNIQUE,
    description:
      "The number of people who were served your Page's posts in their News Feed whether it entered their screen or not. Posts include statuses, photos, links, videos and more.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_VIRAL]: {
    label: 'page_posts_impressions_viral',
    value: PAGE_POSTS_IMPRESSIONS_VIRAL,
    description:
      "The number of times your Page's posts entered a person's screen with social information attached. Social information displays when a person's friend interacted with you Page or post. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_VIRAL_UNIQUE]: {
    label: 'page_posts_impressions_viral_unique',
    value: PAGE_POSTS_IMPRESSIONS_VIRAL_UNIQUE,
    description:
      "The number of people who had any of your Page's posts enter their screen with social information attached. As a form of organic distribution, social information displays when a person's friend interacted with you Page or post. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_NONVIRAL]: {
    label: 'page_posts_impressions_nonviral',
    value: PAGE_POSTS_IMPRESSIONS_NONVIRAL,
    description:
      "The number of times your Page's posts entered a person's screen. This does not include content created about your Page with social information attached. Social information displays when a person's friend interacted with you Page or post. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_NONVIRAL_UNIQUE]: {
    label: 'page_posts_impressions_nonviral_unique',
    value: PAGE_POSTS_IMPRESSIONS_NONVIRAL_UNIQUE,
    description:
      "The number of people who had any posts by your Page enter their screen. This does not include content created about your Page with social information attached. As a form of organic distribution, social information displays when a person's friend interacted with you Page or post. This includes when someone's friend likes or follows your Page, engages with a post, shares a photo of your Page and checks into your Page.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_POSTS_IMPRESSIONS_FREQUENCY_DISTRIBUTION]: {
    label: 'page_posts_impressions_frequency_distribution',
    value: PAGE_POSTS_IMPRESSIONS_FREQUENCY_DISTRIBUTION,
    description:
      'The number of people who saw your Page posts, broken down by how many times people saw your posts.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_LIKE_TOTAL]: {
    label: 'page_actions_post_reactions_like_total',
    value: PAGE_ACTIONS_POST_REACTIONS_LIKE_TOTAL,
    description: 'Daily total post "like" reactions of a page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_LOVE_TOTAL]: {
    label: 'page_actions_post_reactions_love_total',
    value: PAGE_ACTIONS_POST_REACTIONS_LOVE_TOTAL,
    description: 'Daily total post "love" reactions of a page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_WOW_TOTAL]: {
    label: 'page_actions_post_reactions_wow_total',
    value: PAGE_ACTIONS_POST_REACTIONS_WOW_TOTAL,
    description: 'Daily total post "wow" reactions of a page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_HAHA_TOTAL]: {
    label: 'page_actions_post_reactions_haha_total',
    value: PAGE_ACTIONS_POST_REACTIONS_HAHA_TOTAL,
    description: 'Daily total post "haha" reactions of a page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_SORRY_TOTAL]: {
    label: 'page_actions_post_reactions_sorry_total',
    value: PAGE_ACTIONS_POST_REACTIONS_SORRY_TOTAL,
    description: 'Daily total post "sorry" reactions of a page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_ANGER_TOTAL]: {
    label: 'page_actions_post_reactions_anger_total',
    value: PAGE_ACTIONS_POST_REACTIONS_ANGER_TOTAL,
    description: 'Daily total post "anger" reactions of a page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_ACTIONS_POST_REACTIONS_TOTAL]: {
    label: 'page_actions_post_reactions_total',
    value: PAGE_ACTIONS_POST_REACTIONS_TOTAL,
    description: 'Daily total post reactions of a page by type.',
    periods: [DAY],
  },
  [PAGE_FANS]: {
    label: 'page_fans',
    value: PAGE_FANS,
    description: 'The total number of people who have liked your Page.',
    periods: [DAY],
  },
  [PAGE_FANS_LOCALE]: {
    label: 'page_fans_locale',
    value: PAGE_FANS_LOCALE,
    description:
      'Aggregated language data about the people who like your Page based on the default language setting selected when accessing Facebook.',
    periods: [DAY],
  },
  [PAGE_FANS_CITY]: {
    label: 'page_fans_city',
    value: PAGE_FANS_CITY,
    description:
      'Aggregated Facebook location data, sorted by city, about the people who like your Page.',
    periods: [DAY],
  },
  [PAGE_FANS_COUNTRY]: {
    label: 'page_fans_country',
    value: PAGE_FANS_COUNTRY,
    description:
      'The number of people, aggregated per country, that like your Page. Only the 45 countries with the most people that like your Page are included.',
    periods: [DAY],
  },
  [PAGE_FANS_GENDER_AGE]: {
    label: 'page_fans_gender_age',
    value: PAGE_FANS_GENDER_AGE,
    description:
      'The number of people who saw any of your posts at least once, grouped by age and gender. Aggregated demographic data is based on a number of factors, including age and gender information users provide in their Facebook profiles. This number is an estimate.',
    periods: [DAY],
  },
  [PAGE_FAN_ADDS]: {
    label: 'page_fan_adds',
    value: PAGE_FAN_ADDS,
    description: 'The number of new people who have liked your Page.',
    periods: [DAY],
  },
  [PAGE_FAN_ADDS_UNIQUE]: {
    label: 'page_fan_adds_unique',
    value: PAGE_FAN_ADDS_UNIQUE,
    description: 'The number of new people who have liked your Page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_FANS_BY_LIKE_SOURCE]: {
    label: 'page_fans_by_like_source',
    value: PAGE_FANS_BY_LIKE_SOURCE,
    description:
      'This is a breakdown of the number of Page likes from the most common places where people can like your Page. (See possible types)',
    periods: [DAY],
  },
  [PAGE_FANS_BY_LIKE_SOURCE_UNIQUE]: {
    label: 'page_fans_by_like_source_unique',
    value: PAGE_FANS_BY_LIKE_SOURCE_UNIQUE,
    description:
      'The number of people who liked your Page, broken down by the most common places where people can like your Page. (See possible types)',
    periods: [DAY],
  },
  [PAGE_FAN_REMOVES]: {
    label: 'page_fan_removes',
    value: PAGE_FAN_REMOVES,
    description: 'Unlikes of your Page.',
    periods: [DAY],
  },
  [PAGE_FAN_REMOVES_UNIQUE]: {
    label: 'page_fan_removes_unique',
    value: PAGE_FAN_REMOVES_UNIQUE,
    description: 'Unlikes of your Page.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_FANS_BY_UNLIKE_SOURCE_UNIQUE]: {
    label: 'page_fans_by_unlike_source_unique',
    value: PAGE_FANS_BY_UNLIKE_SOURCE_UNIQUE,
    description:
      'The number of people who unliked your Page, broken down by the most common ways people can unlike your Page.',
    periods: [DAY],
  },
  [PAGE_VIDEO_VIEWS]: {
    label: 'page_video_views',
    value: PAGE_VIDEO_VIEWS,
    description:
      "The number of times your Page's videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_PAID]: {
    label: 'page_video_views_paid',
    value: PAGE_VIDEO_VIEWS_PAID,
    description:
      "The number of times your Page's promoted videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_ORGANIC]: {
    label: 'page_video_views_organic',
    value: PAGE_VIDEO_VIEWS_ORGANIC,
    description:
      "The number of times your Page's videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_BY_PAID_NON_PAID]: {
    label: 'page_video_views_by_paid_non_paid',
    value: PAGE_VIDEO_VIEWS_BY_PAID_NON_PAID,
    description:
      "The number of times your Page's videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds, broken down by total, paid, and non-paid. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_AUTOPLAYED]: {
    label: 'page_video_views_autoplayed',
    value: PAGE_VIDEO_VIEWS_AUTOPLAYED,
    description:
      "The number of times your Page's videos automatically played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_CLICK_TO_PLAY]: {
    label: 'page_video_views_click_to_play',
    value: PAGE_VIDEO_VIEWS_CLICK_TO_PLAY,
    description:
      "The number of times your Page's videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds, after people clicked play. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_UNIQUE]: {
    label: 'page_video_views_unique',
    value: PAGE_VIDEO_VIEWS_UNIQUE,
    description:
      "The number of people who viewed your Page's videos for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_REPEAT_VIEWS]: {
    label: 'page_video_repeat_views',
    value: PAGE_VIDEO_REPEAT_VIEWS,
    description:
      "The number of times your Page's videos were replayed for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S]: {
    label: 'page_video_complete_views_30s',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S,
    description:
      "The number of times your Page's videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S_PAID]: {
    label: 'page_video_complete_views_30s_paid',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S_PAID,
    description:
      "The number of times your Page's promoted videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S_ORGANIC]: {
    label: 'page_video_complete_views_30s_organic',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S_ORGANIC,
    description:
      "The number of times your Page's videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED]: {
    label: 'page_video_complete_views_30s_autoplayed',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED,
    description:
      "The number of times your Page's automatically played videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S_CLICK_TO_PLAY]: {
    label: 'page_video_complete_views_30s_click_to_play',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S_CLICK_TO_PLAY,
    description:
      "The number of times your Page's videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds, after people clicked play. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S_UNIQUE]: {
    label: 'page_video_complete_views_30s_unique',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S_UNIQUE,
    description:
      "The number of people who viewed your Page's videos for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_COMPLETE_VIEWS_30S_REPEAT_VIEWS]: {
    label: 'page_video_complete_views_30s_repeat_views',
    value: PAGE_VIDEO_COMPLETE_VIEWS_30S_REPEAT_VIEWS,
    description:
      "The number of times your Page's videos replayed for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [POST_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED]: {
    label: 'post_video_complete_views_30s_autoplayed',
    value: POST_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED,
    description:
      "The number of times your videos automatically played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_30S_CLICKED_TO_PLAY]: {
    label: 'post_video_complete_views_30s_clicked_to_play',
    value: POST_VIDEO_COMPLETE_VIEWS_30S_CLICKED_TO_PLAY,
    description:
      "The number of times your videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds, after people clicked play. During a single instance of a video playing, we'll exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_30S_ORGANIC]: {
    label: 'post_video_complete_views_30s_organic',
    value: POST_VIDEO_COMPLETE_VIEWS_30S_ORGANIC,
    description:
      "The number of times your videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_30S_PAID]: {
    label: 'post_video_complete_views_30s_paid',
    value: POST_VIDEO_COMPLETE_VIEWS_30S_PAID,
    description:
      "The number of times your promoted videos played for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_30S_UNIQUE]: {
    label: 'post_video_complete_views_30s_unique',
    value: POST_VIDEO_COMPLETE_VIEWS_30S_UNIQUE,
    description:
      "The number of people who viewed your videos for at least 30 seconds, or for nearly their total length if they're shorter than 30 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [PAGE_VIDEO_VIEWS_10S]: {
    label: 'page_video_views_10s',
    value: PAGE_VIDEO_VIEWS_10S,
    description:
      "The number of times your Page's videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_10S_PAID]: {
    label: 'page_video_views_10s_paid',
    value: PAGE_VIDEO_VIEWS_10S_PAID,
    description:
      "The number of times your Page's promoted videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_10S_ORGANIC]: {
    label: 'page_video_views_10s_organic',
    value: PAGE_VIDEO_VIEWS_10S_ORGANIC,
    description:
      "The number of times your Page's videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_10S_AUTOPLAYED]: {
    label: 'page_video_views_10s_autoplayed',
    value: PAGE_VIDEO_VIEWS_10S_AUTOPLAYED,
    description:
      "The number of times your Page's videos automatically played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_10S_CLICK_TO_PLAY]: {
    label: 'page_video_views_10s_click_to_play',
    value: PAGE_VIDEO_VIEWS_10S_CLICK_TO_PLAY,
    description:
      "The number of times your Page's videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds, after people clicked play. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_10S_UNIQUE]: {
    label: 'page_video_views_10s_unique',
    value: PAGE_VIDEO_VIEWS_10S_UNIQUE,
    description:
      "The number of people who viewed your Page's videos for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEWS_10S_REPEAT]: {
    label: 'page_video_views_10s_repeat',
    value: PAGE_VIDEO_VIEWS_10S_REPEAT,
    description:
      "The number of times your Page's videos replayed for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIDEO_VIEW_TIME]: {
    label: 'page_video_view_time',
    value: PAGE_VIDEO_VIEW_TIME,
    description: "The total time, in milliseconds, people viewed your Page's video.",
    periods: [DAY],
  },
  [PAGE_VIEWS_TOTAL]: {
    label: 'page_views_total',
    value: PAGE_VIEWS_TOTAL,
    description:
      "The number of times a Page's profile has been viewed by logged in and logged out people.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_LOGOUT]: {
    label: 'page_views_logout',
    value: PAGE_VIEWS_LOGOUT,
    description:
      "The number of times a Page's profile has been viewed by people not logged in to Facebook.",
    periods: [DAY],
  },
  [PAGE_VIEWS_LOGGED_IN_TOTAL]: {
    label: 'page_views_logged_in_total',
    value: PAGE_VIEWS_LOGGED_IN_TOTAL,
    description:
      "The number of times a Page's profile has been viewed by people logged in to Facebook.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_LOGGED_IN_UNIQUE]: {
    label: 'page_views_logged_in_unique',
    value: PAGE_VIEWS_LOGGED_IN_UNIQUE,
    description: 'The number of people logged in to Facebook who have viewed the Page profile.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_EXTERNAL_REFERRALS]: {
    label: 'page_views_external_referrals',
    value: PAGE_VIEWS_EXTERNAL_REFERRALS,
    description: 'Top referrering external domains sending traffic to your Page.',
    periods: [DAY],
  },
  [PAGE_VIEWS_BY_PROFILE_TAB_TOTAL]: {
    label: 'page_views_by_profile_tab_total',
    value: PAGE_VIEWS_BY_PROFILE_TAB_TOTAL,
    description: 'The number of people who have viewed each Page profile tab.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_BY_PROFILE_TAB_LOGGED_IN_UNIQUE]: {
    label: 'page_views_by_profile_tab_logged_in_unique',
    value: PAGE_VIEWS_BY_PROFILE_TAB_LOGGED_IN_UNIQUE,
    description:
      "The number of people logged in to Facebook who have viewed your Page's profile, broken down by each tab.",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_BY_INTERNAL_REFERER_LOGGED_IN_UNIQUE]: {
    label: 'page_views_by_internal_referer_logged_in_unique',
    value: PAGE_VIEWS_BY_INTERNAL_REFERER_LOGGED_IN_UNIQUE,
    description:
      'The number of people logged in to Facebook who have viewed your Page, broken down by the internal referer within Facebook.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_BY_SITE_LOGGED_IN_UNIQUE]: {
    label: 'page_views_by_site_logged_in_unique',
    value: PAGE_VIEWS_BY_SITE_LOGGED_IN_UNIQUE,
    description:
      'The number of people logged in to Facebook who have viewed your Page profile, broken down by the type of device.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_BY_AGE_GENDER_LOGGED_IN_UNIQUE]: {
    label: 'page_views_by_age_gender_logged_in_unique',
    value: PAGE_VIEWS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
    description:
      'The number of people logged in to Facebook who have viewed your Page profile, broken down by gender group.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_VIEWS_BY_REFERERS_LOGGED_IN_UNIQUE]: {
    label: 'page_views_by_referers_logged_in_unique',
    value: PAGE_VIEWS_BY_REFERERS_LOGGED_IN_UNIQUE,
    description: 'Logged-in Page visit counts (unique users) by referral source.',
    periods: [DAY, WEEK],
  },
  [POST_VIDEO_AVG_TIME_WATCHED]: {
    label: 'post_video_avg_time_watched',
    value: POST_VIDEO_AVG_TIME_WATCHED,
    description:
      'The average time, in milliseconds, people viewed your videos. Only available for videos created after August 25th 2016. Returns 0 for reshared videos.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_ORGANIC]: {
    label: 'post_video_complete_views_organic',
    value: POST_VIDEO_COMPLETE_VIEWS_ORGANIC,
    description:
      "The number of times your videos played from the beginning to 95%, or more, of its length, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_ORGANIC_UNIQUE]: {
    label: 'post_video_complete_views_organic_unique',
    value: POST_VIDEO_COMPLETE_VIEWS_ORGANIC_UNIQUE,
    description:
      "The number of people who viewed your videos from the beginning to 95%, or more, of its length, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_PAID]: {
    label: 'post_video_complete_views_paid',
    value: POST_VIDEO_COMPLETE_VIEWS_PAID,
    description:
      "The number of times your promoted videos played from the beginning to 95%, or more, of its length. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video. Returns 0 for reshared videos.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_COMPLETE_VIEWS_PAID_UNIQUE]: {
    label: 'post_video_complete_views_paid_unique',
    value: POST_VIDEO_COMPLETE_VIEWS_PAID_UNIQUE,
    description:
      "The number of people who viewed your promoted videos from the beginning to 95%, or more, of its length. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_RETENTION_GRAPH]: {
    label: 'post_video_retention_graph',
    value: POST_VIDEO_RETENTION_GRAPH,
    description:
      'The number of times your videos played at each interval as a percentage of all views. Videos are divided into 40 equal intervals. This metric does not count impressions while the video was live. Retention graphs may show more impressions later in the video than at the beginning. People might start the video in the middle, skip ahead, save, and rewatch it from that point, or other similar behaviors.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_RETENTION_GRAPH_CLICKED_TO_PLAY]: {
    label: 'post_video_retention_graph_clicked_to_play',
    value: POST_VIDEO_RETENTION_GRAPH_CLICKED_TO_PLAY,
    description:
      'The number of times your videos played at each interval as a percentage of all views, after people clicked play. Videos are divided into 40 equal intervals. This metric does not count impressions while the video was live. Retention graphs may show more impressions later in the video than at the beginning. People might start the video in the middle, skip ahead, save, and rewatch it from that point, or other similar behaviors.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_RETENTION_GRAPH_AUTOPLAYED]: {
    label: 'post_video_retention_graph_autoplayed',
    value: POST_VIDEO_RETENTION_GRAPH_AUTOPLAYED,
    description:
      'The number of times your videos automatically played at each interval as a percentage of all automatic views. Videos are divided into 40 equal intervals.This metric does not count impressions while the video was live. Retention graphs may show more impressions later in the video than at the beginning. People might start the video in the middle, skip ahead, save, and rewatch it from that point, or other similar behaviors.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_ORGANIC]: {
    label: 'post_video_views_organic',
    value: POST_VIDEO_VIEWS_ORGANIC,
    description:
      "The number of times your videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_ORGANIC_UNIQUE]: {
    label: 'post_video_views_organic_unique',
    value: POST_VIDEO_VIEWS_ORGANIC_UNIQUE,
    description:
      "The number of people who viewed your videos for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_PAID]: {
    label: 'post_video_views_paid',
    value: POST_VIDEO_VIEWS_PAID,
    description:
      "The number of times your promoted videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_PAID_UNIQUE]: {
    label: 'post_video_views_paid_unique',
    value: POST_VIDEO_VIEWS_PAID_UNIQUE,
    description:
      "The number of people who viewed your promoted videos for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_LENGTH]: {
    label: 'post_video_length',
    value: POST_VIDEO_LENGTH,
    description: 'The length, in milliseconds, of a video post.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS]: {
    label: 'post_video_views',
    value: POST_VIDEO_VIEWS,
    description:
      "The number of times your videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video. This includes live views.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_UNIQUE]: {
    label: 'post_video_views_unique',
    value: POST_VIDEO_VIEWS_UNIQUE,
    description:
      "The number of people who viewed your videos for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_AUTOPLAYED]: {
    label: 'post_video_views_autoplayed',
    value: POST_VIDEO_VIEWS_AUTOPLAYED,
    description:
      "The number of times your videos automatically played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_CLICKED_TO_PLAY]: {
    label: 'post_video_views_clicked_to_play',
    value: POST_VIDEO_VIEWS_CLICKED_TO_PLAY,
    description:
      "The number of times your videos played for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds, after people clicked play. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_15S]: {
    label: 'post_video_views_15s',
    value: POST_VIDEO_VIEWS_15S,
    description:
      "The number of times your videos played for at least 15 seconds, or for nearly their total length if they're shorter than 15 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_60S_EXCLUDES_SHORTER]: {
    label: 'post_video_views_60s_excludes_shorter',
    value: POST_VIDEO_VIEWS_60S_EXCLUDES_SHORTER,
    description:
      "The number of times your videos played for at least 60 seconds. This metric is counted only for videos that are 60 seconds or longer. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_10S]: {
    label: 'post_video_views_10s',
    value: POST_VIDEO_VIEWS_10S,
    description:
      "The number of times your videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_10S_UNIQUE]: {
    label: 'post_video_views_10s_unique',
    value: POST_VIDEO_VIEWS_10S_UNIQUE,
    description:
      "The number of people who viewed your videos for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_10S_AUTOPLAYED]: {
    label: 'post_video_views_10s_autoplayed',
    value: POST_VIDEO_VIEWS_10S_AUTOPLAYED,
    description:
      "The number of times your videos played automatically for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_10S_CLICKED_TO_PLAY]: {
    label: 'post_video_views_10s_clicked_to_play',
    value: POST_VIDEO_VIEWS_10S_CLICKED_TO_PLAY,
    description:
      "The number of times your videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds, after people clicked play. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_10S_ORGANIC]: {
    label: 'post_video_views_10s_organic',
    value: POST_VIDEO_VIEWS_10S_ORGANIC,
    description:
      "The number of times your videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds, by organic reach. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_10S_PAID]: {
    label: 'post_video_views_10s_paid',
    value: POST_VIDEO_VIEWS_10S_PAID,
    description:
      "The number of times your promoted videos played for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. For each impression of a video, we'll count video views separately and exclude any time spent replaying the video.",
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_10S_SOUND_ON]: {
    label: 'post_video_views_10s_sound_on',
    value: POST_VIDEO_VIEWS_10S_SOUND_ON,
    description:
      "The number of times your videos played with sound on for at least 10 seconds, or for nearly their total length if they're shorter than 10 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEWS_SOUND_ON]: {
    label: 'post_video_views_sound_on',
    value: POST_VIDEO_VIEWS_SOUND_ON,
    description:
      "The number of times your videos played with sound on for at least 3 seconds, or for nearly their total length if they're shorter than 3 seconds. During a single instance of a video playing, we'll exclude any time spent replaying the video.",
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEW_TIME]: {
    label: 'post_video_view_time',
    value: POST_VIDEO_VIEW_TIME,
    description:
      'The total time, in milliseconds, your videos played, including videos played for less than 3 seconds and replays. Returns 0 for reshared videos.',
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEW_TIME_ORGANIC]: {
    label: 'post_video_view_time_organic',
    value: POST_VIDEO_VIEW_TIME_ORGANIC,
    description:
      'The total time, in milliseconds, your videos played by organic reach. Returns 0 for reshared videos.',
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEW_TIME_BY_AGE_BUCKET_AND_GENDER]: {
    label: 'post_video_view_time_by_age_bucket_and_gender',
    value: POST_VIDEO_VIEW_TIME_BY_AGE_BUCKET_AND_GENDER,
    description:
      'The total time, in milliseconds, your videos played for your Top Audiences, age and gender.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEW_TIME_BY_REGION_ID]: {
    label: 'post_video_view_time_by_region_id',
    value: POST_VIDEO_VIEW_TIME_BY_REGION_ID,
    description:
      'The total time, in milliseconds, your videos played for your Top 45 Locations, Region - Country.',
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_VIEWS_BY_DISTRIBUTION_TYPE]: {
    label: 'post_video_views_by_distribution_type',
    value: POST_VIDEO_VIEWS_BY_DISTRIBUTION_TYPE,
    description:
      'The number of times your videos played by distribution type; page_owned and shared.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEW_TIME_BY_DISTRIBUTION_TYPE]: {
    label: 'post_video_view_time_by_distribution_type',
    value: POST_VIDEO_VIEW_TIME_BY_DISTRIBUTION_TYPE,
    description:
      'The total time, in milliseconds, your videos played by distribution type; page_owned and shared.',
    periods: [LIFETIME],
  },
  [POST_VIDEO_VIEW_TIME_BY_COUNTRY_ID]: {
    label: 'post_video_view_time_by_country_id',
    value: POST_VIDEO_VIEW_TIME_BY_COUNTRY_ID,
    description:
      'The total number of minutes your videos played for your Top 45 Locations; Country.',
    periods: [LIFETIME],
  },
  [PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE_UNIQUE]: {
    label: 'page_content_activity_by_action_type_unique',
    value: PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE_UNIQUE,
    description:
      "The number of people talking about your Page's stories, by Page story type. (See possible types)",
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONTENT_ACTIVITY_BY_AGE_GENDER_UNIQUE]: {
    label: 'page_content_activity_by_age_gender_unique',
    value: PAGE_CONTENT_ACTIVITY_BY_AGE_GENDER_UNIQUE,
    description:
      'The number of People Talking About the Page by user age and gender. This number is an estimate.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONTENT_ACTIVITY_BY_CITY_UNIQUE]: {
    label: 'page_content_activity_by_city_unique',
    value: PAGE_CONTENT_ACTIVITY_BY_CITY_UNIQUE,
    description: 'The number of People Talking About the Page by user city.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONTENT_ACTIVITY_BY_COUNTRY_UNIQUE]: {
    label: 'page_content_activity_by_country_unique',
    value: PAGE_CONTENT_ACTIVITY_BY_COUNTRY_UNIQUE,
    description:
      'The number of people, aggregated per country, that are talking about your Page. Only the 45 countries with the most people talking about your page are included.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONTENT_ACTIVITY_BY_LOCALE_UNIQUE]: {
    label: 'page_content_activity_by_locale_unique',
    value: PAGE_CONTENT_ACTIVITY_BY_LOCALE_UNIQUE,
    description: 'The number of People Talking About the Page by user language.',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONTENT_ACTIVITY]: {
    label: 'page_content_activity',
    value: PAGE_CONTENT_ACTIVITY,
    description: 'The number of stories created about your Page (Stories).',
    periods: [DAY, WEEK, DAYS_28],
  },
  [PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE]: {
    label: 'page_content_activity_by_action_type',
    value: PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE,
    description:
      "The number of stories about your Page's stories, by Page story type. (See possible types)",
    periods: [DAY, WEEK, DAYS_28],
  },
  [POST_ACTIVITY]: {
    label: 'post_activity',
    value: POST_ACTIVITY,
    description: "The number of stories generated about your Page post ('Stories').",
    periods: [LIFETIME],
  },
  [POST_ACTIVITY_UNIQUE]: {
    label: 'post_activity_unique',
    value: POST_ACTIVITY_UNIQUE,
    description:
      "The number of people who created a story about your Page post ('People Talking About This' / PTAT).",
    periods: [LIFETIME],
  },
  [POST_ACTIVITY_BY_ACTION_TYPE]: {
    label: 'post_activity_by_action_type',
    value: POST_ACTIVITY_BY_ACTION_TYPE,
    description: 'The number of stories created about your Page post, by action type.',
    periods: [LIFETIME],
  },
  [POST_ACTIVITY_BY_ACTION_TYPE_UNIQUE]: {
    label: 'post_activity_by_action_type_unique',
    value: POST_ACTIVITY_BY_ACTION_TYPE_UNIQUE,
    description: 'The number of people who created a story about your Page post, by action type.',
    periods: [LIFETIME],
  },
  [PAGE_DAILY_VIDEO_AD_BREAK_AD_IMPRESSIONS_BY_CROSSPOST_STATUS]: {
    label: 'page_daily_video_ad_break_ad_impressions_by_crosspost_status',
    value: PAGE_DAILY_VIDEO_AD_BREAK_AD_IMPRESSIONS_BY_CROSSPOST_STATUS,
    description:
      'The total number of times an ad was shown during ad breaks in crossposted videos.',
    periods: [DAY],
  },
  [PAGE_DAILY_VIDEO_AD_BREAK_CPM_BY_CROSSPOST_STATUS]: {
    label: 'page_daily_video_ad_break_cpm_by_crosspost_status',
    value: PAGE_DAILY_VIDEO_AD_BREAK_CPM_BY_CROSSPOST_STATUS,
    description:
      'The average amount paid by advertisers for 1,000 of impressions of their ads in a crossposted videos. This is a gross number and includes the amount paid to Facebook.',
    periods: [DAY],
  },
  [PAGE_DAILY_VIDEO_AD_BREAK_EARNINGS_BY_CROSSPOST_STATUS]: {
    label: 'page_daily_video_ad_break_earnings_by_crosspost_status',
    value: PAGE_DAILY_VIDEO_AD_BREAK_EARNINGS_BY_CROSSPOST_STATUS,
    description:
      'An estimate of the amount you earned from ad breaks in a crossposted videos, based on the number of impressions and CPM of ads shown. Actual payments may differ if there are content ownership claims or other adjustments.',
    periods: [DAY],
  },
  [POST_VIDEO_AD_BREAK_AD_IMPRESSIONS]: {
    label: 'post_video_ad_break_ad_impressions',
    value: POST_VIDEO_AD_BREAK_AD_IMPRESSIONS,
    description: 'The total number of times an ad was shown during ad breaks in your videos.',
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_AD_BREAK_EARNINGS]: {
    label: 'post_video_ad_break_earnings',
    value: POST_VIDEO_AD_BREAK_EARNINGS,
    description:
      'An estimate of the amount you earned from ad breaks in your videos, based on the number of impressions and CPM of ads shown. Actual payments may differ if there are content ownership claims or other adjustments.',
    periods: [LIFETIME, DAY],
  },
  [POST_VIDEO_AD_BREAK_AD_CPM]: {
    label: 'post_video_ad_break_ad_cpm',
    value: POST_VIDEO_AD_BREAK_AD_CPM,
    description:
      'The average amount paid by advertisers for 1,000 impressions of their ads in your videos. This number also includes the amount paid to Facebook.',
    periods: [LIFETIME, DAY],
  },
};

export const metricsByCategory = [
  {
    label: 'All',
    metrics: Object.keys(metrics),
  },
  {
    label: 'Page content',
    metrics: [PAGE_TAB_VIEWS_LOGIN_TOP_UNIQUE, PAGE_TAB_VIEWS_LOGIN_TOP, PAGE_TAB_VIEWS_LOGOUT_TOP],
  },
  {
    label: 'Page CTA clicks',
    metrics: [
      PAGE_TOTAL_ACTIONS,
      PAGE_CTA_CLICKS_LOGGED_IN_TOTAL,
      PAGE_CTA_CLICKS_LOGGED_IN_UNIQUE,
      PAGE_CTA_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
      PAGE_CTA_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
      PAGE_CTA_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
      PAGE_CTA_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
      PAGE_CALL_PHONE_CLICKS_LOGGED_IN_UNIQUE,
      PAGE_CALL_PHONE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
      PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
      PAGE_CALL_PHONE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
      PAGE_CALL_PHONE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
      PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_UNIQUE,
      PAGE_GET_DIRECTIONS_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
      PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
      PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
      PAGE_GET_DIRECTIONS_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
      PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE,
      PAGE_WEBSITE_CLICKS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
      PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_COUNTRY_UNIQUE,
      PAGE_WEBSITE_CLICKS_LOGGED_IN_BY_CITY_UNIQUE,
      PAGE_WEBSITE_CLICKS_BY_SITE_LOGGED_IN_UNIQUE,
    ],
  },
  {
    label: 'Page Engagement',
    metrics: [
      PAGE_ENGAGED_USERS,
      PAGE_POST_ENGAGEMENTS,
      PAGE_CONSUMPTIONS,
      PAGE_CONSUMPTIONS_UNIQUE,
      PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE,
      PAGE_CONSUMPTIONS_BY_CONSUMPTION_TYPE_UNIQUE,
      PAGE_PLACES_CHECKIN_TOTAL,
      PAGE_PLACES_CHECKIN_TOTAL_UNIQUE,
      PAGE_PLACES_CHECKIN_MOBILE,
      PAGE_PLACES_CHECKIN_MOBILE_UNIQUE,
      PAGE_PLACES_CHECKINS_BY_AGE_GENDER,
      PAGE_PLACES_CHECKINS_BY_LOCALE,
      PAGE_PLACES_CHECKINS_BY_COUNTRY,
      PAGE_NEGATIVE_FEEDBACK,
      PAGE_NEGATIVE_FEEDBACK_UNIQUE,
      PAGE_NEGATIVE_FEEDBACK_BY_TYPE,
      PAGE_NEGATIVE_FEEDBACK_BY_TYPE_UNIQUE,
      PAGE_POSITIVE_FEEDBACK_BY_TYPE,
      PAGE_POSITIVE_FEEDBACK_BY_TYPE_UNIQUE,
      PAGE_FANS_ONLINE,
      PAGE_FANS_ONLINE_PER_DAY,
      PAGE_FAN_ADDS_BY_PAID_NON_PAID_UNIQUE,
    ],
  },
  {
    label: 'Page Impressions',
    metrics: [
      PAGE_IMPRESSIONS,
      PAGE_IMPRESSIONS_UNIQUE,
      PAGE_IMPRESSIONS_PAID,
      PAGE_IMPRESSIONS_PAID_UNIQUE,
      PAGE_IMPRESSIONS_ORGANIC,
      PAGE_IMPRESSIONS_ORGANIC_UNIQUE,
      PAGE_IMPRESSIONS_VIRAL,
      PAGE_IMPRESSIONS_VIRAL_UNIQUE,
      PAGE_IMPRESSIONS_NONVIRAL,
      PAGE_IMPRESSIONS_NONVIRAL_UNIQUE,
      PAGE_IMPRESSIONS_BY_STORY_TYPE,
      PAGE_IMPRESSIONS_BY_STORY_TYPE_UNIQUE,
      PAGE_IMPRESSIONS_BY_CITY_UNIQUE,
      PAGE_IMPRESSIONS_BY_COUNTRY_UNIQUE,
      PAGE_IMPRESSIONS_BY_LOCALE_UNIQUE,
      PAGE_IMPRESSIONS_BY_AGE_GENDER_UNIQUE,
      PAGE_IMPRESSIONS_FREQUENCY_DISTRIBUTION,
      PAGE_IMPRESSIONS_VIRAL_FREQUENCY_DISTRIBUTION,
    ],
  },
  {
    label: 'Page Posts',
    metrics: [
      PAGE_POSTS_IMPRESSIONS,
      PAGE_POSTS_IMPRESSIONS_UNIQUE,
      PAGE_POSTS_IMPRESSIONS_PAID,
      PAGE_POSTS_IMPRESSIONS_PAID_UNIQUE,
      PAGE_POSTS_IMPRESSIONS_ORGANIC,
      PAGE_POSTS_IMPRESSIONS_ORGANIC_UNIQUE,
      PAGE_POSTS_SERVED_IMPRESSIONS_ORGANIC_UNIQUE,
      PAGE_POSTS_IMPRESSIONS_VIRAL,
      PAGE_POSTS_IMPRESSIONS_VIRAL_UNIQUE,
      PAGE_POSTS_IMPRESSIONS_NONVIRAL,
      PAGE_POSTS_IMPRESSIONS_NONVIRAL_UNIQUE,
      PAGE_POSTS_IMPRESSIONS_FREQUENCY_DISTRIBUTION,
    ],
  },
  {
    label: 'Page Reactions',
    metrics: [
      PAGE_ACTIONS_POST_REACTIONS_LIKE_TOTAL,
      PAGE_ACTIONS_POST_REACTIONS_LOVE_TOTAL,
      PAGE_ACTIONS_POST_REACTIONS_WOW_TOTAL,
      PAGE_ACTIONS_POST_REACTIONS_HAHA_TOTAL,
      PAGE_ACTIONS_POST_REACTIONS_SORRY_TOTAL,
      PAGE_ACTIONS_POST_REACTIONS_ANGER_TOTAL,
      PAGE_ACTIONS_POST_REACTIONS_TOTAL,
    ],
  },
  {
    label: 'Page User Demographics',
    metrics: [
      PAGE_FANS,
      PAGE_FANS_LOCALE,
      PAGE_FANS_CITY,
      PAGE_FANS_COUNTRY,
      PAGE_FANS_GENDER_AGE,
      PAGE_FAN_ADDS,
      PAGE_FAN_ADDS_UNIQUE,
      PAGE_FANS_BY_LIKE_SOURCE,
      PAGE_FANS_BY_LIKE_SOURCE_UNIQUE,
      PAGE_FAN_REMOVES,
      PAGE_FAN_REMOVES_UNIQUE,
      PAGE_FANS_BY_UNLIKE_SOURCE_UNIQUE,
    ],
  },
  {
    label: 'Page Video Views',
    metrics: [
      PAGE_VIDEO_VIEWS,
      PAGE_VIDEO_VIEWS_PAID,
      PAGE_VIDEO_VIEWS_ORGANIC,
      PAGE_VIDEO_VIEWS_BY_PAID_NON_PAID,
      PAGE_VIDEO_VIEWS_AUTOPLAYED,
      PAGE_VIDEO_VIEWS_CLICK_TO_PLAY,
      PAGE_VIDEO_VIEWS_UNIQUE,
      PAGE_VIDEO_REPEAT_VIEWS,
      PAGE_VIDEO_COMPLETE_VIEWS_30S,
      PAGE_VIDEO_COMPLETE_VIEWS_30S_PAID,
      PAGE_VIDEO_COMPLETE_VIEWS_30S_ORGANIC,
      PAGE_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED,
      PAGE_VIDEO_COMPLETE_VIEWS_30S_CLICK_TO_PLAY,
      PAGE_VIDEO_COMPLETE_VIEWS_30S_UNIQUE,
      PAGE_VIDEO_COMPLETE_VIEWS_30S_REPEAT_VIEWS,
      POST_VIDEO_COMPLETE_VIEWS_30S_AUTOPLAYED,
      POST_VIDEO_COMPLETE_VIEWS_30S_CLICKED_TO_PLAY,
      POST_VIDEO_COMPLETE_VIEWS_30S_ORGANIC,
      POST_VIDEO_COMPLETE_VIEWS_30S_PAID,
      POST_VIDEO_COMPLETE_VIEWS_30S_UNIQUE,
      PAGE_VIDEO_VIEWS_10S,
      PAGE_VIDEO_VIEWS_10S_PAID,
      PAGE_VIDEO_VIEWS_10S_ORGANIC,
      PAGE_VIDEO_VIEWS_10S_AUTOPLAYED,
      PAGE_VIDEO_VIEWS_10S_CLICK_TO_PLAY,
      PAGE_VIDEO_VIEWS_10S_UNIQUE,
      PAGE_VIDEO_VIEWS_10S_REPEAT,
      PAGE_VIDEO_VIEW_TIME,
    ],
  },
  {
    label: 'Page Views',
    metrics: [
      PAGE_VIEWS_TOTAL,
      PAGE_VIEWS_LOGOUT,
      PAGE_VIEWS_LOGGED_IN_TOTAL,
      PAGE_VIEWS_LOGGED_IN_UNIQUE,
      PAGE_VIEWS_EXTERNAL_REFERRALS,
      PAGE_VIEWS_BY_PROFILE_TAB_TOTAL,
      PAGE_VIEWS_BY_PROFILE_TAB_LOGGED_IN_UNIQUE,
      PAGE_VIEWS_BY_INTERNAL_REFERER_LOGGED_IN_UNIQUE,
      PAGE_VIEWS_BY_SITE_LOGGED_IN_UNIQUE,
      PAGE_VIEWS_BY_AGE_GENDER_LOGGED_IN_UNIQUE,
      PAGE_VIEWS_BY_REFERERS_LOGGED_IN_UNIQUE,
    ],
  },
  {
    label: 'Page Video Posts',
    metrics: [
      POST_VIDEO_AVG_TIME_WATCHED,
      POST_VIDEO_COMPLETE_VIEWS_ORGANIC,
      POST_VIDEO_COMPLETE_VIEWS_ORGANIC_UNIQUE,
      POST_VIDEO_COMPLETE_VIEWS_PAID,
      POST_VIDEO_COMPLETE_VIEWS_PAID_UNIQUE,
      POST_VIDEO_RETENTION_GRAPH,
      POST_VIDEO_RETENTION_GRAPH_CLICKED_TO_PLAY,
      POST_VIDEO_RETENTION_GRAPH_AUTOPLAYED,
      POST_VIDEO_VIEWS_ORGANIC,
      POST_VIDEO_VIEWS_ORGANIC_UNIQUE,
      POST_VIDEO_VIEWS_PAID,
      POST_VIDEO_VIEWS_PAID_UNIQUE,
      POST_VIDEO_LENGTH,
      POST_VIDEO_VIEWS,
      POST_VIDEO_VIEWS_UNIQUE,
      POST_VIDEO_VIEWS_AUTOPLAYED,
      POST_VIDEO_VIEWS_CLICKED_TO_PLAY,
      POST_VIDEO_VIEWS_15S,
      POST_VIDEO_VIEWS_60S_EXCLUDES_SHORTER,
      POST_VIDEO_VIEWS_10S,
      POST_VIDEO_VIEWS_10S_UNIQUE,
      POST_VIDEO_VIEWS_10S_AUTOPLAYED,
      POST_VIDEO_VIEWS_10S_CLICKED_TO_PLAY,
      POST_VIDEO_VIEWS_10S_ORGANIC,
      POST_VIDEO_VIEWS_10S_PAID,
      POST_VIDEO_VIEWS_10S_SOUND_ON,
      POST_VIDEO_VIEWS_SOUND_ON,
      POST_VIDEO_VIEW_TIME,
      POST_VIDEO_VIEW_TIME_ORGANIC,
      POST_VIDEO_VIEW_TIME_BY_AGE_BUCKET_AND_GENDER,
      POST_VIDEO_VIEW_TIME_BY_REGION_ID,
      POST_VIDEO_VIEWS_BY_DISTRIBUTION_TYPE,
      POST_VIDEO_VIEW_TIME_BY_DISTRIBUTION_TYPE,
      POST_VIDEO_VIEW_TIME_BY_COUNTRY_ID,
    ],
  },
  {
    label: 'Stories',
    metrics: [
      PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE_UNIQUE,
      PAGE_CONTENT_ACTIVITY_BY_AGE_GENDER_UNIQUE,
      PAGE_CONTENT_ACTIVITY_BY_CITY_UNIQUE,
      PAGE_CONTENT_ACTIVITY_BY_COUNTRY_UNIQUE,
      PAGE_CONTENT_ACTIVITY_BY_LOCALE_UNIQUE,
      PAGE_CONTENT_ACTIVITY,
      PAGE_CONTENT_ACTIVITY_BY_ACTION_TYPE,
      POST_ACTIVITY,
      POST_ACTIVITY_UNIQUE,
      POST_ACTIVITY_BY_ACTION_TYPE,
      POST_ACTIVITY_BY_ACTION_TYPE_UNIQUE,
    ],
  },
  {
    label: 'Video Ad Breaks',
    metrics: [
      PAGE_DAILY_VIDEO_AD_BREAK_AD_IMPRESSIONS_BY_CROSSPOST_STATUS,
      PAGE_DAILY_VIDEO_AD_BREAK_CPM_BY_CROSSPOST_STATUS,
      PAGE_DAILY_VIDEO_AD_BREAK_EARNINGS_BY_CROSSPOST_STATUS,
      POST_VIDEO_AD_BREAK_AD_IMPRESSIONS,
      POST_VIDEO_AD_BREAK_EARNINGS,
      POST_VIDEO_AD_BREAK_AD_CPM,
    ],
  },
];

export const instagramPeriodOptions = [
  { label: 'Day', value: DAY },
  { label: 'Week', value: WEEK },
  { label: '28 Days', value: DAYS_28 },
  { label: 'lifetime', value: LIFETIME },
];

export const instagramMetricOptions = [
  {
    label: 'audience_city',
    value: AUDIENCE_CITY,
    periods: [LIFETIME],
    description:
      "The cities of the IG User's followers. Does not include current day's data. Not available on IG Users with fewer than 100 followers.",
  },
  {
    label: 'audience_country',
    value: AUDIENCE_COUNTRY,
    periods: [LIFETIME],
    description:
      "The countries of the IG User's followers. Does not include current day's data. Not available on IG Users with fewer than 100 followers.",
  },
  {
    label: 'audience_gender_age',
    value: AUDIENCE_GENDER_AGE,
    periods: [LIFETIME],
    description:
      "The gender and age distribution of the IG User's followers. Does not include current day's data. Not available on IG Users with fewer than 100 followers.",
  },
  {
    label: 'audience_locale',
    value: AUDIENCE_LOCALE,
    periods: [LIFETIME],
    description:
      "The locales by country codes of the IG User's followers. Does not include current day's data. Not available on IG Users with fewer than 100 followers.",
  },
  {
    label: 'email_contacts',
    value: EMAIL_CONTACTS,
    periods: [DAY],
    description: "Total number of taps on the email link in the IG User's profile.",
  },
  {
    label: 'follower_count',
    value: FOLLOWER_COUNT,
    periods: [DAY],
    description:
      'Total number of new followers each day within the specified range. Returns a maximum of 30 days worth of data. Not available on IG Users with fewer than 100 followers.',
  },
  {
    label: 'get_directions_clicks',
    value: GET_DIRECTIONS_CLICKS,
    periods: [DAY],
    description: "Total number of taps on the directions link in the IG User's profile.",
  },
  {
    label: 'impressions',
    value: IMPRESSIONS,
    periods: [DAY, WEEK, DAYS_28],
    description:
      "Total number of times the IG User's IG Media objects (i.e. posts, stories and promotions) have been viewed. Includes ad activity generated through the API, Facebook ads interfaces, and the Promote feature. Does not include profile views.",
  },
  {
    label: 'online_followers',
    value: ONLINE_FOLLOWERS,
    periods: [LIFETIME],
    description:
      "Total number of the IG User's followers who were online during the specified range. Not available on IG Users with fewer than 100 followers.",
  },
  {
    label: 'phone_call_clicks',
    value: PHONE_CALL_CLICKS,
    periods: [DAY],
    description: "Total number of taps on the call link in the IG User's profile.",
  },
  {
    label: 'profile_views',
    value: PROFILE_VIEWS,
    periods: [DAY],
    description:
      "Total number of users who have viewed the IG User's profile within the specified period.",
  },
  {
    label: 'reach',
    value: REACH,
    periods: [DAY, WEEK, DAYS_28],
    description:
      "Total number of unique users who have viewed at least one of the IG User's IG Media. Repeat views and views across different IG Media owned by the IG User by the same user are only counted as a single view. Includes ad activity generated through the API, Facebook ads interfaces, and the Promote feature.",
  },
  {
    label: 'text_message_clicks',
    value: TEXT_MESSAGE_CLICKS,
    periods: [DAY],
    description: "Total number of taps on the text message link in the IG User's profile.",
  },
  {
    label: 'website_clicks',
    value: WEBSITE_CLICKS,
    periods: [DAY],
    description: "Total number of taps on the website link in the IG User's profile.",
  },
];
